<template>
  <div>
    <el-table :data="channels.data" class="w100" stripe v-loading="loading">
      <el-table-column
        label="Channel name"
        prop="channel_name"
        sortable
      ></el-table-column>
      <el-table-column label="Channel url" prop="url" sortable>
        <template slot-scope="props">
          <a
            :href="`https://www.youtube.com/channel/${props.row.channel_id}`"
            target="_blank"
          >
            {{ `https://www.youtube.com/channel/${props.row.channel_id}` }}
          </a>
        </template>
      </el-table-column>
      <el-table-column label="Tier" prop="tier" sortable>
        <template slot-scope="props">
          <p v-if="props.row.tier == 1">Bronze</p>
          <p v-else-if="props.row.tier == 2">Silver</p>
          <p v-else>Free</p>
        </template>
      </el-table-column>
      <el-table-column label="User connected" prop="user_id" sortable>
        <template slot-scope="props">
          <el-tag v-if="props.row.user_id" type="success">Yes</el-tag>
          <el-tag v-else type="danger">No</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Created at" prop="created_at" sortable>
        <template slot-scope="props">
          {{ props.row.created_at | datetime }}
        </template>
      </el-table-column>
      <el-table-column label="Actions" align="right">
        <template slot-scope="props">
          <el-tooltip content="Delete" placement="top">
            <el-button
              type="danger"
              class="mr5"
              circle
              size="small"
              icon="el-icon-close"
              @click="deleteChannel(props.row.channel_id)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="float-right"
      background
      @size-change="sizeChange"
      @current-change="currentChange"
      :current-page.sync="channels.current_page"
      :page-sizes="[5, 10, 25, 50, 100]"
      :page-size="page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="channels.total"
    ></el-pagination>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState('preapproved', ['loading', 'channels', 'page_size'])
  },

  methods: {
    ...mapActions('preapproved', ['read', 'deleteChannel']),
    ...mapMutations('testimonial', ['setPage', 'setPageSize', 'setOrdering']),

    sizeChange(page_size) {
      this.setPageSize(page_size)
      this.read()
    },
    currentChange(page) {
      this.setPage(page)
      this.read()
    },
    sort(d) {
      this.setOrdering({
        column: d.prop,
        type: this.ascDesc(d.order)
      })
      this.read()
    }
  },

  created() {
    this.read()
  }
}
</script>
